import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import PropTypes from 'prop-types';
import { TIME_GRID_DAY, TIME_GRID_WEEK, DAY_GRID_MONTH, LIST_WEEK } from '../constants';

CalendarViewToggle.propTypes = {
  value: PropTypes.oneOf([TIME_GRID_DAY, TIME_GRID_WEEK, DAY_GRID_MONTH, LIST_WEEK]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function CalendarViewToggle({ value, onChange }) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={onChange}
      size="small"
      aria-label="calendar view"
      sx={(theme) => {
        const { main, lighter } = theme.palette.primary;

        return {
          bgcolor: 'common.white',
          border: `0.5px solid ${main}`,
          '& .MuiToggleButtonGroup-grouped': {
            margin: 0,
            border: '0 !important',
          },
          '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
            borderLeft: `1.5px solid ${main} !important`,
          },
          '& .MuiToggleButton-root': {
            fontSize: '14px',
            fontWeight: 400,
            color: main,
            textTransform: 'none',
          },
          '& .MuiToggleButton-root:hover': {
            borderColor: main,
          },
          '& .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover': {
            borderColor: main,
            backgroundColor: lighter,
            zIndex: 1,
            color: main,
          },
        };
      }}
    >
      <ToggleButton value={TIME_GRID_DAY} aria-label="day view">
        Day
      </ToggleButton>
      <ToggleButton value={TIME_GRID_WEEK} aria-label="week view">
        Week
      </ToggleButton>
      <ToggleButton value={DAY_GRID_MONTH} aria-label="month view">
        Month
      </ToggleButton>
      <ToggleButton value={LIST_WEEK} aria-label="list view">
        List
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
